import React from "react";
import { Routes, Route } from "react-router-dom";
// import { useDispatch } from "react-redux";
import { Calculadoras, Variacao, Curva } from "../../../pagesPublic";
// import services from "../../../services";
// import { acIndicadoresChanged } from "../../../store/actions";

const CalculadorasRoutes = () => {
  // const storeDispatch = useDispatch();
  return (
    <Routes>
      <Route path={"/curva"} element={<Curva />} />
      <Route
        path={"/variacao"}
        element={<Variacao />}
        // loader={async () => {
        //   console.log("loader");
        //   return services.indicadores.list((rRes) => {
        //     storeDispatch(acIndicadoresChanged(rRes.data));
        //     return rRes.data;
        //   });
        // }}
      />
      <Route path={"*"} element={<Calculadoras />} />
    </Routes>
  );
};

export default CalculadorasRoutes;
